import Modal from '@components/Modal';
import Buttons from '@/components/Buttons';
import NotEditableModalBody from './NotEditableBody';
import s from './NotEditableModal.module.scss';

type Props = {
  reason: string;
  onClose: () => void;
  onReload: () => void;
};

const NotEditableModal: React.FC<Props> = ({ reason, onClose, onReload }) => {
  const isReloadable = (
    reason === 'is-upgraded'
    || reason === 'is-upgrading'
    || reason === 'is-submitted'
  );
  const isCloseable = !isReloadable;

  const handleReload = (): void => {
    onReload();
    onClose();
  };

  return (
    <Modal
      title={'Questionnaire is not editable'}
      onClose={isCloseable ? onClose : undefined}
    >
      <div className={s.padding}>
        <NotEditableModalBody reason={reason} />
        {isReloadable && (
          <Buttons isSecondary onClick={handleReload}>
            Reload
          </Buttons>
        )}
      </div>
    </Modal>
  );
};

export default NotEditableModal;
